import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Link} from 'react-router-dom'

export default class LinkDuo extends Component {
  static propTypes = {
    to: PropTypes.string,
    download: PropTypes.bool.isRequired
  }

  static defaultProps = {
    download: false
  }

  isInternalLink(url) {
    if (!url) {
      return url
    }
    return Boolean(url.includes(window.location.host) || !url.includes('http'))
  }

  isFile(url) {
    if(!url) return false
    return url.includes('wp-content')
  }


  getPathFromAbsoluteUrl(url) {
    if(!url || !url.includes(window.location.host)) return url
    return url.split(window.location.host)[1]
  }

  render() {
    const {
      download,
      to,
      children,
      ...rest
    } = this.props

    delete rest.headerBold
    delete rest.headerLight

    // download:
    if (download || this.isFile(to)) {
      return (
        <a
          {...rest}
          data-download
          href={to}
          target="_self"
          download
        >
          {children}
        </a>
      )
    }

    // internal:
    if (this.isInternalLink(to)) {
      return (
        <Link
          {...rest}
          data-internal
          to={this.getPathFromAbsoluteUrl(to)}
        >
          {children}
        </Link>
      )
    }

    // external:
    return (
      <a
        {...rest}
        data-external
        href={to}
        target="_blank"
        rel="nofollow noopener"
      >
        {children}
      </a>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/LinkDuo/LinkDuo.js